<template>
    <div v-if="modalShow">
        <b-modal id="abrir-modal-pdf-adesao" hide-header hide-footer centered v-model="modalShow"
            :style="{ height: '70vh', width: '70vw' }" size="xl" no-close-on-esc no-close-on-backdrop>
            <div class="d-flex flex-column align-items-center justify-center-center my-2 text-center container-modal ">

                <vue-pdf-app ref="pdfContainer" :style="{ height: '100%', width: '100%' }" :config="config"
                    :pdf=pdf.blob theme="dark" @scroll="verificarLeitura" />

                <div class="mt-1" v-if="modoCriacao">
                    <b-form-checkbox v-model="readandAcceptTerm" class="contract" :disabled="!leuTodoTermo && !readandAcceptTerm">
                        Informo que li e estou ciente das condições para adesão na campanha de vacinação do SESI.
                    </b-form-checkbox>
                </div>

                <div class="mt-1 d-flex">
                    <button v-if="modoCriacao" class="mr-1 btn custom-blue" @click.prevent="aceitouTermo"
                        :disabled="!readandAcceptTerm">
                        Continuar
                    </button>
                    <a v-if="!modoCriacao" @click.prevent="downloadTermo" class="mr-1 btn custom-blue">
                        <feather-icon size="18" icon="DownloadIcon" class="mr-50 text-white" />
                        <span class="align-middle text-white">Download Termo</span>
                    </a>
                    <button class="btn custom-outline-blue" @click.prevent="fecharModal">Fechar</button>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
import { BModal, BFormTextarea, BFormCheckbox } from "bootstrap-vue";

export default {
    components: {
        BModal,
        BFormTextarea,
        BFormCheckbox
    },
    props: {
        modalShow: {
            required: true,
            type: Boolean
        },
        modoCriacao: {
            required: true,
            type: Boolean
        },
        pdf: {
            required: true
        },
    },
    mounted() {
        if (this.modalShow) {
            this.esperarPdfRenderizado();
        }
    },
    data() {
        return {
            config: {
                toolbar: false
            },
            readandAcceptTerm: false,
            leuTodoTermo: false
        };
    },
    methods: {
        fecharModal() {
            this.$emit('fechar');
        },
        aceitouTermo() {
            this.$emit('aceitouTermo');
        },
        downloadTermo() {
            const link = document.createElement('a');
            link.href = this.pdf.blob;
            link.download = this.pdf.nome;
            link.click();
            URL.revokeObjectURL(link.href);
        },
        esperarPdfRenderizado() {
            const observer = new MutationObserver((mutations, obs) => {
                const viewerContainer = document.getElementById('viewerContainer');

                if (viewerContainer) {
                    viewerContainer.addEventListener('scroll', this.verificarLeitura);
                    obs.disconnect();
                }
            });

            observer.observe(document.body, {
                childList: true,
                subtree: true
            });
        },
        verificarLeitura() {
            const viewerContainer = document.getElementById('viewerContainer');
            if (!viewerContainer) return;
            const { scrollTop, clientHeight, scrollHeight } = viewerContainer;
            if (scrollTop + clientHeight >= scrollHeight - 10) {
                this.leuTodoTermo = true;
            }
        },
    },
    watch: {
        modalShow(novoValor) {
            if (novoValor) {
                this.esperarPdfRenderizado();
            } else {
                this.leuTodoTermo = false;
            }
        }
    },
};
</script>

<style lang="scss" scoped>
.container-modal {
    width: 90vw;
    height: 70vh;
}

.text-white {
    color: white;
}

.border-modal {
    border: 2px solid #2772C0;
}
</style>
